import {
  Component,
  EventEmitter,
  OnInit,
  Optional,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  allowedImageFormats,
  getInstanceRegion,
  isLargeScreen,
  radiusRangeListGlobal,
  uploadedFileCheck,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { UserProfileService } from '../../../profile/user-profile/user-profile.service';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { DialogRef } from '../../../shared/components/modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { ClientsService } from '../clients/clients.service';

@Component({
  selector: 'gtapp-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrl: './company-profile.component.scss',
  standalone: false,
})
export class CompanyProfileComponent implements OnInit {
  @ViewChild('companyDialog') templateRef: any = TemplateRef<any>;
  isAdmin: any;

  @Output() getEmitData = new EventEmitter();
  instanceRegion = getInstanceRegion();
  companyDetails: any;
  companyForm: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    // abn: new UntypedFormControl('', [
    //   Validators.required,
    //   Validators.pattern(/^\d+$/),
    //   Validators.minLength(11),
    //   Validators.maxLength(11),
    // ]),
    abn: new UntypedFormControl(''),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    phone: new UntypedFormControl('', [
      Validators.minLength(7),
      Validators.maxLength(10),
      //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
      Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      Validators.required,
    ]),
    addressLookup: new UntypedFormControl(''),
    address1: new UntypedFormControl(''),
    address2: new UntypedFormControl('', [Validators.required]),
    address3: new UntypedFormControl(''),
    city_name: new UntypedFormControl('', [Validators.required]),
    postcode: new UntypedFormControl(''),
    longitude: new UntypedFormControl('', [Validators.required]),
    latitude: new UntypedFormControl('', [Validators.required]),
    country_name: new UntypedFormControl(this.instanceRegion, [
      Validators.required,
    ]),
    state_code: new UntypedFormControl('', [Validators.required]),
    state_name: new UntypedFormControl('', [Validators.required]),
  });
  licenseForm: UntypedFormGroup = new UntypedFormGroup({
    issuer_state: new UntypedFormControl(null, [Validators.required]),
    license_class: new UntypedFormControl(null, [Validators.required]),
    license_number: new UntypedFormControl(null, [Validators.required]),
    valid_till: new UntypedFormControl(null, [Validators.required]),
  });

  smtpConfigForm: UntypedFormGroup = new UntypedFormGroup({
    smtp_host: new UntypedFormControl('', [Validators.required]),
    smtp_port: new UntypedFormControl(587, [Validators.required]),
    smtp_email: new UntypedFormControl('', [
      Validators.required,
      Validators.email,
    ]),
    //smtp.gmail.com
    //qzzi ngxd uelk obbj
    smtp_password: new UntypedFormControl('', [Validators.required]),
    protocol: new UntypedFormControl('tls', [Validators.required]),
    use_tls: new UntypedFormControl(true, [Validators.required]),
    use_ssl: new UntypedFormControl(false, [Validators.required]),
    additional_info: new UntypedFormControl(''),
  });

  countryData: any;

  userData: any;

  companyLicenses: any = [];
  newlicense: any;
  classData: any = [];
  routeState: any;

  showLicenseAddClass: boolean = false;
  licenseId: any;
  licenseClassData: any;
  largeView: Boolean = isLargeScreen;
  cardActionIcons: any = [
    {
      condition: function () {
        return {
          icon: 'fs-5 fa-solid fa-circle-minus text-danger',
          status: 'primary',
          title: 'Delete License',
          confirm: true,
          show: 'top',
          type: 'copy',
        };
      },
    },
  ];

  showWebcam: boolean = false;
  dialogref: any;

  subscriberLogoUrl: any;

  companyDialogueStep: number = 1;
  sampleEmailAddress: string = '';
  smtpCorrectlyConfigured: boolean = false;
  smtpErrorMessage: string = '';
  showPassword: any = false;

  subscriberSettingsInfo: any = {};

  radiusRangeList: any = radiusRangeListGlobal;

  subscriberSettingsInfoBakup: any = {};

  //https://app.shortcut.com/sendem/story/12159/refactor-address-lookup-region-restriction-logic
  addressLookupDataList: any = [];
  selectedRegionsForAddressLookup = new Set();

  constructor(
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private profileService: UserProfileService,

    private clientService: ClientsService,
    @Optional() protected dialogRef: DialogRef,
    private dialogService: ModalDialogueService,
    private route: ActivatedRoute,
    private dataCheckService: DataCheckService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
  ) {
    this.getCompanyDetails();
    this.userData = this.appService.getUserData();

    this.isAdmin = this.dataCheckService.isUserAdmin();

    this.routeState = this.route.snapshot.paramMap.get('state');
  }

  ngOnInit(): void {
    if (this.routeState) {
      setTimeout(() => {
        this.openTemplate();
      }, 100);
    }
  }

  getCompanyDetails() {
    this.spinnerService.show();
    this.profileService.fetchCompanyDetails().subscribe((res: any) => {
      if (res['status'] === 'success') {
        this.spinnerService.hide();
        this.companyDetails = res?.data;
        this.getSubscriberAccountSettings();
        this.companyForm.reset();
        this.formatCompanyData();
      }
      this.spinnerService.hide();
    });
  }

  formatCompanyData() {
    this.appService.initializeBootstrapTooltips();
    this.companyForm.patchValue({
      name: this.companyDetails?.name,
      abn: this.companyDetails?.abn,
      email: this.companyDetails?.email,
      phone: this.companyDetails?.phone,
      address1: this.companyDetails?.address?.address1 || '',
      address2: this.companyDetails?.address?.address2,
      address3: this.companyDetails?.address?.address3,
      city_name: this.companyDetails?.address?.city_name,
      postcode: this.companyDetails?.address?.postcode,
      state_code: this.companyDetails?.address?.state_code,
      state_name:
        this.companyDetails?.address?.state_name ||
        this.companyDetails?.address?.state_code,
      country_name:
        this.companyDetails?.address?.country_name || this.instanceRegion,
      latitude: this.companyDetails?.address?.latitude,
      longitude: this.companyDetails?.address?.longitude,
    });
    this.smtpConfigForm.patchValue(this.companyDetails?.smtp_config);

    if (this.companyDetails?.license) {
      this.companyLicenses = this.companyDetails?.license;
    }
    if (this.companyDetails?.logo_url) {
      this.subscriberLogoUrl = this.companyDetails?.logo_url;
    }
  }

  updateData() {
    if (this.companyForm.valid) {
      this.spinnerService.show();
      var requestData = this.companyForm.value;
      requestData.abn = requestData?.abn || null;
      this.clientService
        .updateCompanyDetails(requestData)
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.companyDetails = response['data'];
            this.toasterService.setMessage({
              successMessage: response['message'],
              errorMessage: '',
            });

            this.companyDetails = response?.data;
            this.companyForm.reset();
            this.formatCompanyData();

            this.routeState = undefined;
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
        });
    }
  }

  openTemplate(
    template: TemplateRef<any> = this.templateRef,
    source: string = 'companyDetails',
  ) {
    switch (source) {
      case 'companyDetails':
        this.smtpCorrectlyConfigured = false;
        this.formatCompanyData();
        break;

      case 'address':
        const addressLookupCountries = JSON.parse(
          JSON.stringify(
            this.subscriberSettingsInfo?.address_lookup_countries || [],
          ),
        );

        this.addressLookupDataList = [
          {
            code: 'au',
            label: 'Australia',
            selected:
              addressLookupCountries?.includes('au') ||
              (this.instanceRegion === 'AUSTRALIA' &&
                !addressLookupCountries?.length),
          },
          {
            code: 'nz',
            label: 'New Zealand',
            selected:
              addressLookupCountries?.includes('nz') ||
              (this.instanceRegion === 'NEW ZEALAND' &&
                !addressLookupCountries?.length),
          },
          {
            code: 'pg',
            label: 'Papua New Guinea',
            selected: addressLookupCountries?.includes('pg'),
          },
        ];
        this.updateRegionList();

        break;
    }

    this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }

  forceUppercaseConditionally(event: any) {
    this.companyForm.controls['city_name'].setValue(
      event.target.value.toUpperCase(),
    );
  }
  openCamPopup() {
    this.showWebcam = true;
    var button: any = document.getElementById('subscriberLogoFileInput');
    button.click();
  }
  onFileSubmit(file: any) {
    if (file) {
      this.spinnerService.show();
      let fileData: FormData = new FormData();
      fileData.append('file', file);

      this.appService
        .formDataApi('company_profile', fileData, false, { change_logo: 1 })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.companyDetails = response?.data;
            this.companyForm.reset();
            this.formatCompanyData();
            window.location.reload();
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
          this.spinnerService.hide();
        });
    }
  }
  removeImage() {
    this.spinnerService.show();
    this.clientService
      .updateCompanyDetails({}, { remove_logo: 1 })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();

          this.companyDetails = response?.data;
          this.companyForm.reset();
          this.formatCompanyData();
          window.location.reload();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }

  async handleFileInput(item: any) {
    let file = item.files.item(0);
    let fileSize: number = file.size;
    let fileName: string = file.name;
    let fileExtension: string = fileName.split('.').pop() || '';
    let fileCheckError = await uploadedFileCheck(fileExtension, fileSize);
    if (fileCheckError) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: fileCheckError,
      });
    } else {
      this.onFileSubmit(item.files.item(0));
    }
  }
  mobileNumberCheck() {
    if (!this.companyForm.value?.phone) {
      this.companyForm.controls['phone'].setValue(null);
      this.companyForm.controls['phone'].removeValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    } else {
      this.companyForm.controls['phone'].setValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    }
  }
  sendSampleEmail() {
    this.smtpErrorMessage = '';
    this.spinnerService.show();
    let requestData: any = this.smtpConfigForm.value;
    requestData[
      `${this.smtpConfigForm.value?.protocol === 'ssl' ? 'use_ssl' : 'use_ttl'}`
    ] = true;
    requestData['sample_email_address'] = this.smtpConfigForm.value.smtp_email;
    this.clientService
      .updateSMTPConfig(requestData, { send_sample_mail: 1 })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.smtpCorrectlyConfigured = true;
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.smtpErrorMessage = response['message'];
        }
      });
  }
  removeSmtpConfig() {
    let dialogMsg =
      'Stop sending reports from ' +
      this.companyDetails?.smtp_config?.smtp_email;
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: '',
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        this.clientService
          .updateSMTPConfig({}, { delete: 1 })
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.spinnerService.hide();
              this.companyDetails = response?.data;
              this.companyForm.reset();
              this.smtpConfigForm.reset();
              this.formatCompanyData();
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
            } else {
              this.spinnerService.hide();

              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
          });
      }
    });
  }
  configureSMTP() {
    this.spinnerService.show();
    let requestData: any = this.smtpConfigForm.value;
    requestData[
      `${this.smtpConfigForm.value?.protocol === 'ssl' ? 'use_ssl' : 'use_ttl'}`
    ] = true;

    this.clientService.updateSMTPConfig(requestData).then((response: any) => {
      if (response['status'] == 'success') {
        this.spinnerService.hide();
        this.companyDetails = response?.data;
        this.companyForm.reset();
        this.smtpConfigForm.reset();
        this.formatCompanyData();
        this.toasterService.setMessage({
          successMessage: response['message'],
          errorMessage: '',
        });
      } else {
        this.spinnerService.hide();

        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }

  changeSLayer(layer: string) {
    switch (layer) {
      case 'tls':
        this.smtpConfigForm.controls['smtp_port'].setValue(587);
        break;
      case 'ssl':
        this.smtpConfigForm.controls['smtp_port'].setValue(465);
        break;
    }
  }
  formatSubscriberSettings(data: any) {
    this.subscriberSettingsInfo = data;
    if (
      !('runsheet_site_task_completion_range' in this.subscriberSettingsInfo)
    ) {
      this.subscriberSettingsInfo['runsheet_site_task_completion_range'] = 100;
    }
    if (!('job_stale_after_creation_alert' in this.subscriberSettingsInfo)) {
      this.subscriberSettingsInfo['job_stale_after_creation_alert'] = 15;
    }
    if (!('in_transit_missed_alert' in this.subscriberSettingsInfo)) {
      this.subscriberSettingsInfo['in_transit_missed_alert'] = 5;
    }
    if (!('job_onsite_stale_alert' in this.subscriberSettingsInfo)) {
      this.subscriberSettingsInfo['job_onsite_stale_alert'] = 0;
    }
    if (!('enhance_security' in this.subscriberSettingsInfo)) {
      this.subscriberSettingsInfo['enhance_security'] = true;
    }
  }

  getSubscriberAccountSettings() {
    this.profileService
      .getUpdateSystemSetting({}, { get_settings: 1 })
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.formatSubscriberSettings(response?.data);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  updateSubscriberAccountSettings() {
    let updatedSettings = this.subscriberSettingsInfo;
    this.profileService
      .getUpdateSystemSetting({ system_settings: updatedSettings }, {})
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          this.formatSubscriberSettings(response?.data);

          this.toasterService.setMessage({
            successMessage: 'Setting Saved',
            errorMessage: '',
          });
          false;
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  toggleAddressLookupSetting(event: any, countryCode: string = 'nz') {
    let checkbox = event.target as HTMLInputElement;
    let originalState = checkbox.checked;
    const existingCountries =
      this.subscriberSettingsInfo?.address_lookup_countries?.filter(
        (cCode: any) => cCode !== countryCode,
      ) || [];
    if (originalState) {
      existingCountries.push(countryCode);
    }
    this.subscriberSettingsInfo.address_lookup_countries = [
      ...existingCountries,
    ];
    this.updateSubscriberAccountSettings();
  }
  toggleSubscriberSettings(event: any, field: string) {
    let checkbox = event.target as HTMLInputElement;
    let originalState = checkbox.checked;
    this.subscriberSettingsInfo[field] = originalState;
    this.updateSubscriberAccountSettings();
  }
  updateSettingValue(value: any, valueString: string) {
    if (value != this.subscriberSettingsInfo?.[valueString]) {
      this.subscriberSettingsInfo[valueString] = value;
      this.updateSubscriberAccountSettings();
    }
  }
  updateAddressLookupSelection(region: any) {
    region.selected = !region?.selected;
    this.updateRegionList();
  }
  updateRegionList() {
    this.selectedRegionsForAddressLookup.clear();
    this.addressLookupDataList?.forEach((region: any) => {
      if (region?.selected) {
        this.selectedRegionsForAddressLookup.add(region?.code);
      }
    });
  }
  updateAddressLookupRegions() {
    this.subscriberSettingsInfo.address_lookup_countries = [
      ...this.selectedRegionsForAddressLookup,
    ];
    this.updateSubscriberAccountSettings();
  }
}
